
class Message {
  warning (text = '', timeout = 5000) {}
  success (text = '', timeout = 5000) {}
  error (text = '', timeout = 5000) {}
}

export default function message (vue) {
  vue.prototype.$message = new Message()
}
